import {
  LetterHeaderContent,
  PAGECONFIG_TO_PIXEL_RATIO,
} from "@/modules/abstract-ui/forms/document-editor/BFDocument.service";
import React from "react";
import ReactDOMServer from "react-dom/server";

type Props = {
  content: LetterHeaderContent;
  debug?: boolean;
};

export const getVacancyContractHeader = (
  content: LetterHeaderContent,
  debug = false
) =>
  ReactDOMServer.renderToString(
    <VacancyContractHeader content={content} debug={debug} />
  );

const VacancyContractHeader = (props: Props) => {
  const { content, debug } = props;

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: 10 * PAGECONFIG_TO_PIXEL_RATIO,
        overflow: "visible",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      {content.logo && (
        <img
          src={content.logo}
          alt="Logo"
          style={{
            marginTop: "5px",
            height: 10 * PAGECONFIG_TO_PIXEL_RATIO,
            objectFit: "contain",
            border: debug ? "solid 2px red" : undefined,
          }}
        />
      )}
      <hr
        style={{
          marginTop: "15px",
          padding: 0,
          width: "80%",
        }}
      />
    </div>
  );
};

export default VacancyContractHeader;
